"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberField = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const input_styles_1 = require("@/components/common/input/input.styles");
const textfield_helpers_1 = require("@/components/common/input/semantics/textfield.helpers");
require("@/components/common/icon-button/icon-button");
require("@/components/common/input/input");
const utils_1 = require("@/utils");
let NumberField = class NumberField extends (0, textfield_helpers_1.withTextfieldState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.step = 1;
    }
    render() {
        return (0, lit_1.html) `
      ${(0, textfield_helpers_1.renderFieldLabel)(this.inputId, this.label, this.optional)}
      <div class="textfield-control" aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}>
        <mm-input
          input-id=${this.inputId}
          .type=${'number'}
          .value=${this.value}
          .name=${this.name}
          .placeholder=${this.placeholder}
          aria-label=${this.label ?? this.placeholder ?? lit_1.nothing}
          .min=${this.min}
          .max=${this.max}
          .step=${this.step}
          ?disabled=${this.disabled}
          aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}
          aria-describedby=${this.describedBy || lit_1.nothing}
          @input=${this.handleInput}
        ></mm-input>
        <mm-icon-button
          variant="ghost"
          size="small"
          icon=${icon_names_1.ICON_NAMES.SUBTRACT}
          aria-label="감소"
          tooltip-placement="bottom"
          ?disabled=${this.disabled}
          @click=${this.handleDecrementClick}
        ></mm-icon-button>
        <mm-icon-button
          variant="ghost"
          size="small"
          icon=${icon_names_1.ICON_NAMES.ADD}
          aria-label="증가"
          tooltip-placement="bottom"
          ?disabled=${this.disabled}
          @click=${this.handleIncrementClick}
        ></mm-icon-button>
      </div>
      ${(0, textfield_helpers_1.renderFieldDescription)(this.description, `${this.inputId}-description`)}
      ${(0, textfield_helpers_1.renderFieldValidation)(`${this.inputId}-validation`, this.validationText)}
    `;
    }
    get numericValue() {
        const parsed = Number(this.value);
        if (Number.isFinite(parsed))
            return parsed;
        if (typeof this.min === 'number')
            return this.min;
        return 0;
    }
    clamp(value) {
        if (typeof this.min === 'number' && value < this.min)
            return this.min;
        if (typeof this.max === 'number' && value > this.max)
            return this.max;
        return value;
    }
    commit(value) {
        this.value = String(this.clamp(value));
        (0, utils_1.emit)(this, 'input', { value: this.value });
        (0, utils_1.emit)(this, 'change', { value: this.value });
    }
    handleDecrementClick() {
        if (this.disabled)
            return;
        this.commit(this.numericValue - this.step);
    }
    handleIncrementClick() {
        if (this.disabled)
            return;
        this.commit(this.numericValue + this.step);
    }
};
NumberField.styles = input_styles_1.textfieldStyles;
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], NumberField.prototype, "min", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], NumberField.prototype, "max", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], NumberField.prototype, "step", void 0);
NumberField = __decorate([
    (0, decorators_js_1.customElement)('mm-numberfield')
], NumberField);
exports.NumberField = NumberField;
//# sourceMappingURL=data:application/json;base64,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